import React from "react";

// COMPONENTS
import BackPageBtn from "components/Buttons/PrevPage";

function JobChancellery() {
  return (
    <main className="margined-navbar">
      <section className="section--jobs-single">
        <div className="container">
          <div className="content-bar font-white">
            <BackPageBtn />
          </div>
          <h4>Продавец художественных и канцелярских товаров </h4>
          <div className="content">
            <p>
              Мы хотим развить наш художественно-канцелярский отдел, чтобы он
              тоже стал лучшим в регионе, как и наш книжный.
            </p>
            <p>
              Сперва может показаться, что эта вакансия для продавцов. И отчасти
              это действительно так, но только отчасти. В первую очередь мы ищем
              специалистов в определенных сферах, людей, заинтересованных в
              развитии любимой отрасли.
            </p>
            <p>
              Нам нужен тот, кто хорошо разбирается в маркерах, кисточках,
              бумаге, карандашах, блокнотах – словом, во всем, что называют
              бездушными определениями вроде «канцтоваров» и товаров для
              художников. Причем, любить настолько, чтобы быть готовым сделать
              это своей работой: разбираться в брендах и видах, следить за
              новостями индустрии, ежедневно без устали узнавать что-то новое.
            </p>
            <p>
              Нам не очень важны уровень образования, опыт работы или умение
              работать с кассой. Больше внимания мы обращаем на ваши знания,
              художественный вкус, эстетство, умение рисовать, красиво писать и
              фотографировать. Пригодятся в нашем деле грамотная речь, капелька
              харизмы и английский хотя бы на школьном уровне. Мы ищем скорее
              художника, дизайнера, иллюстратора или архитектора, чем продавца
              или товароведа.
            </p>
            <p className="font-bold">Вы нам подходите, если:</p>
            <li>
              — увлечены искусством, сами рисуете или занимаетесь каллиграфией,
              разбираетесь в художественных и канцелярских товарах;
            </li>
            <li>
              — постоянно в поиске новой информации в различных источниках — от
              книг до роликов на ютубе и телеграм-каналов;
            </li>
            <li>— хотите общаться с людьми, умеете их заинтересовать.</li>
            <p className="font-bold">Приветствуются:</p>
            <li>— профильное образование в сфере, которой вы увлечены;</li>
            <li>— харизма, грамотная речь;</li>
            <li>— умение писать и вести соцсети.</li>
            <p className="font-bold">Что надо делать:</p>
            <li>— ходить к нам на работу хотя бы на 20 часов в неделю;</li>
            <li>
              — увлеченно общаться с посетителями без навязчивости и назидания;
            </li>
            <li>
              — поддерживать порядок в пространстве, участвовать в закупках,
              инвентаризациях и прочих рабочих процессах проекта.
            </li>
            <p className="font-bold">Что мы предлагаем:</p>
            <li>
              — работа в интересном проекте среди единомышленников; красивое
              здание, вкусный кофе, регулярные мероприятия;
            </li>
            <li>— гибкий посменный график;</li>
            <li>— развоз до работы и обратно;</li>
            <li>
              — белый оклад и не менее белая премия по результатам продаж 2 раза
              в месяц без задержек;
            </li>
            <li>— скидки на книги и канцелярку, бесплатный кофе.</li>
            <p>
              Для начала, мы примем вас на должность младшего научного
              специалиста на ставку 800 рублей за восьмичасовую смену, или 100
              рублей в час.
            </p>
            <p>
              Ваш рабочий день будет состоять из работы в зале и работы в
              архиве. Архивная работа — это помощь с заказом новых книг и разбор
              поставок. По окончании испытательного срока активные участники
              жизни пространства будут посвящены в резиденты с прибавкой к
              зарплате и должностным обязанностям.
            </p>
            <p>
              Сейчас вам достаточно написать на электронную почту
              <a href="mailto: labor@drugie-knigi.ru">
                {" "}
                labor@drugie-knigi.ru
              </a>{" "}
              с темой письма «Кандидат в продавцы». В ответ мы отправим вам
              небольшую анкету. Если от нас не будет ответа больше трех дней,
              проверьте папку «Спам», а потом продублируйте ваше письмо.
            </p>
            <p>
              Если и это не помогло, напишите нам в соцсетях или позвоните по
              телефону <a href="tel:+79122000199">+79122000199</a>
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default JobChancellery;
